import { Card } from "@scuf/common";
import { Chart } from "@scuf/charts";
import React, { useEffect, useState } from "react";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";
import { plotBackground } from "../../../config/colors";


export default function DomoMasaStacker() {
  const [masaConcentrado, setMasaConcentrado] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  // Fecha inicial y final
  const [date, setDate] = useState({ start: "19-01-2023", end: "25-01-2023" });

  // Objeto inicial de la peticion
  const initialFetch = {
    idSeccion: 6,
    secuencia: 30,
    ultimo: 0,
    frecuencia: 5,
    dias: 7,
  };

  useEffect(() => {
    // Peticion de datos al API
    async function fetchData() {
      // Solo nos traemos la data de la peticion
    const { data } = await getValoresPeriodo(initialFetch);

    populateMasaConcentrado(data);
      //#endregion
    }

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function populateMasaConcentrado(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Masa Concentrado Stacker"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setMasaConcentrado({
      fecha: arrFechas,
      value: arrValues,
    });
  }
 
  return (
    <>
       <Card>
        <Card.Content>
          <Chart
            plotBackgroundColor={plotBackground}
            title={"Perfil Domo Masa Stacker"}
            subtitle={"Periodo " + date.start + " - " + date.end}
          >
            {/** -------------------------------- Masa Concentrado Stacker --------------------------------------- */}
            <Chart.Line
              name="Masa Concentrado Stacker"
              data={masaConcentrado.value}
              yAxis={0}
            />
           
            {/** -------------------------------- FECHAS --------------------------------------- */}
            <Chart.XAxis categories={masaConcentrado.fecha} />

            <Chart.YAxis
              labelSuffix=" t/h"
              title="Flujo Másico, t/h"
              lineWidth={2}
              lineColor="white"
              min={0}
            />

            <Chart.YAxis
              labelSuffix=""
              title=""
              lineWidth={2}
              opposite={true}
              lineColor="white"
            />

            <Chart.Tooltip valueSuffix="" />
          </Chart>
        </Card.Content>
      </Card>
    </>
  );
}
